const transformedObject = (originalObject, id) => {
  return {
    id: originalObject.id,
    title: originalObject.title,
    option1: originalObject.title,
    option2: null,
    option3: null,
    sku: `SKU_${originalObject.id}_${originalObject.title}`,
    requires_shipping: true,
    taxable: originalObject.taxable,
    featured_image: null,
    available: originalObject.available,
    name: `Product Name - ${originalObject.title}`, // Đặt tên theo yêu cầu của bạn
    public_title: originalObject.title,
    options: [originalObject.title],
    price: originalObject.price,
    weight: originalObject.weight,
    compare_at_price: originalObject.compare_at_price,
    inventory_management: "shopify",
    barcode: "",
    requires_selling_plan: false,
    unit_price: originalObject.unit_price,
    unit_price_measurement: {
      measured_type: "weight",
      quantity_value: originalObject.weight.toString(),
      quantity_unit: "g",
      reference_value: originalObject.base_measure,
      reference_unit: "kg",
    },
    selling_plan_allocations: [],
    price_formatted: BSS_B2B.formatMoney(originalObject.price),
    price_formatted_without_trailing_zeros: `€${(originalObject.price / 100)
      .toFixed(2)
      .replace(/\.00$/, "")}`,
    compare_at_price_formatted: originalObject.compare_at_price
      ? `€${(originalObject.compare_at_price / 100).toFixed(2)}`
      : "",
    compare_at_price_formatted_without_trailing_zeros:
      originalObject.compare_at_price
        ? `€${(originalObject.compare_at_price / 100)
            .toFixed(2)
            .replace(/\.00$/, "")}`
        : "",
    product_id: id,
  };
};

async function showTDByVariantID(productID, variant) {
  console.log(productID);
  if (productID) {
    const res = await fetch(`/search?q=id:"${productID}"&view=bss.b2b`);
    const data = await res.json();
    if (data?.length && typeof BSS_B2B) {
      let product = data[0];
      console.log(product);
      if (product.variants)
        bssB2BProduct.variantIdArrayMap = product.variants.reduce(
          (acc, item) => {
            acc[item.id] = transformedObject(item, product.id);
            return acc;
          },
          {}
        );
      if (variant) {
        const variantData = product.variants?.find(
          (variant) => variant.title === variant
        );
        product.price = variantData?.price;
      }
      BSS_B2B.shopData.product = product;
      const bssB2BProductVatClosestForm =
        document.querySelector("quick-add-drawer");
      if (bssB2BProductVatClosestForm) {
        BSS_B2B.td.handleVariantChangeEvents(
          bssB2BProductVatClosestForm,
          BSS_B2B.shopData,
          false
        );
      }
    }
  }
}

let timeBack = 10;
const handleF = () => {
  if ($(".card__info").length > 0 && BSS_B2B?.page?.isCartPage()) {
    setTimeout(() => {
      BSS_B2B.td.changeCollectionItemVatPriceWithoutCP(
        BSS_B2B.shopData,
        BSS_B2B.td.getAppliedRuleCollectionPage(BSS_B2B, BSS_B2B.shopData)
      );
    }, 200);
  } else if (timeBack-- > 0) setTimeout(handleF, 300);
};

document.addEventListener("DOMContentLoaded", function () {
  // fix change variant collection
  const cards = document.querySelectorAll("product-card");
  if (cards.length) {
    cards.forEach((card) => {
      const optionsVariant = card.querySelectorAll(".card__swatches label");
      if (optionsVariant.length) {
        optionsVariant.forEach((option) => {
          option.addEventListener("click", () => {
            const variantID = option.getAttribute("data-variant-id");
            const priceEle = card.querySelector(
              "[bss-b2b-product-id][bss-b2b-product-price]"
            );
            const check = priceEle.querySelector(".bss-check");
            if (!check && variantID) {
              //remove attribute
              priceEle.removeAttribute("bss-b2b-product-active");
              BSS_B2B.cp.changeProductPrice(
                JSON.parse($("#bss-b2b-store-data").html()),
                false,
                false,
                false,
                variantID
              );

              // fix add to cart
              const formDatas = card.querySelectorAll('product-form[data-variant-id]')
              if(formDatas.length){
                formDatas.forEach((form) => {
                  const dataVariantId = form.getAttribute('data-variant-id');
                  if(dataVariantId !== variantID) {
                    form.style.display = "none";
                  } else {
                    form.style.display = "unset"
                  }
                })
              } 
            }
          });
        });
      }
    });
  }

  let typingTimer;
  let doneTypingInterval = 1500;
  $("[id*='header-search']").on("input", function () {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
  });

  function doneTyping() {
    BSS_B2B.td.changeCollectionItemVatPriceWithoutCP(
      BSS_B2B.shopData,
      BSS_B2B.td.getAppliedRuleCollectionPage(BSS_B2B, BSS_B2B.shopData)
    );
  }

  const modalButtons = document.querySelectorAll(".js-quick-add");
  if (modalButtons.length) {
    modalButtons.forEach((button) => {
      button.addEventListener("click", async () => {
        setTimeout(async () => {
          const vatEle = document.querySelector(
            ".quick-add__product-details [data-product-id]"
          );
          const productId = vatEle?.getAttribute("data-product-id");
          showTDByVariantID(productId, false);

          // fix change variants
          const options = document.querySelectorAll(
            ".option-selector__btns label"
          );
          if (options.length) {
            options.forEach((opt) => {
              const urlParams = new URLSearchParams(
                new URL(
                  "https://durabl-b2b.myshopify.com" +
                    $(".quick-add-info__details .js-prod-link").attr("href")
                ).search
              );
              const variantValue = urlParams.get("variant");
              opt.addEventListener("click", () => {
                showTDByVariantID(productId, variantValue);
              });
            });
          }
        }, 2000);
      });
    });
  }
});

window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const fixVariantIdInputInHandleVariantChangeEvents = ({
  variantId,
  bssB2BProductVatClosestForm,
  bssVariantInput,
}) => {
  return Number(variantId);
};
window.BSS_B2B.addFilter(
  "fix_variantId_input_in_handleVariantChangeEvents",
  fixVariantIdInputInHandleVariantChangeEvents
);

if (typeof BSS_B2B != undefined) {
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.makeChangesAfterClickAjaxCart(500);
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
    }, 500);
  });

  setTimeout(() => {
    const targetMiniCart = document.querySelector(".cart-drawer");
    if (targetMiniCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
        BSS_B2B.makeChangesAfterClickAjaxCart(500);
        BSS_B2B.cart.fixer(
          JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),
          false,
          false
        );
        setTimeout(() => {
          BSS_B2B.handleCartCheckoutBtn(
            JSON.parse($("#bss-b2b-store-data").html())
          );
        }, 1000);
      });
      mutationObserver.observe(targetMiniCart, { attributes: true });
    }
  }, 500);

  if (window.location.pathname.includes("/cart")) {
    setTimeout(() => {
      BSS_B2B.cp.changeProductPrice(
        JSON.parse($("#bss-b2b-store-data").html()),
        false,
        false,
        false
      );
    }, 1000);
  }

  //fix spam checkout
  setTimeout(() => {
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $button.css({ "pointer-events": "none", opacity: "0.6" });
      $button.text("Loading ...");
      setTimeout(() => {
        $button.css({ "pointer-events": "unset", opacity: "1" });
        $button.text(oldText);
      }, 2000);
    }

    $(document).on(
      "click dblclick",
      'button[name="checkout"]',
      handleButtonClick
    );
  }, 500);

  BSS_B2B.customTriggerCheckoutBtn = function (checkoutBtn) {
    window.location.href = "/checkout";
  };
}
